import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

export const Route = createFileRoute("/national-west")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/restore-west/", location.searchStr), replace: true, statusCode: 301 });
  },
});